// Define the JWT payload structure based on what your backend actually sends
export interface JWTPayload {
  sub: string; // User ID (subject)
  username: string; // User email
  name?: string; // User name (optional for backward compatibility)
  role: string;
  permissions: string[];
  organizationIds: string[]; // Only organization IDs are included in JWT
  managedAccountantIds?: string[];
  customPermissions?: string[]; // Custom permissions for organization_user role
  phone?: string; // Phone number (optional)
  exp: number;
  iat: number;
  iss: string;
  aud: string[];
  azp: string;
  scope: string;
  auth_time: number;
  typ: string;
}

export const decodeJWT = (token: string): JWTPayload => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    const decoded = JSON.parse(jsonPayload) as JWTPayload;
    
    return decoded;
  } catch (error) {
    throw new Error('Invalid token');
  }
}; 